export default {
  // ApiUrl: 'http://192.168.4.24:8000/app_dev.php/api/v1',
  // ApiRoot: 'http://192.168.4.24:8000',

  ApiUrl: 'https://gestion.imm-innovacion.com/app_dev.php/api/v1',
  ApiRoot: 'https://gestion.imm-innovacion.com',
};



// WEBPACK FOOTER //
// ./src/app/services/configuracion/config.ts